import FolderIcon from "@mui/icons-material/Folder";
import ShareIcon from "@mui/icons-material/Share";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';

import { getTenantName } from "app/utils/tenantUtils";

// const referenceDownloaderTenants = ["ops", "trexo-prod", "trexo-uat", "trexo-dev", "trexo dev", "trexo uat", "trexo prod", "trexo qa", "trexo qa admin"].map(tenant => tenant.toLowerCase());
const referenceDownloaderTenants = ["ops", "trexo-prod", "trexo-ops", "trexo-uat", "trexo-qa", "trexo-dev"];
const filing371Tenants = ["trexo-prod", "trexo-ops", "trexo-uat", "trexo-qa", "trexo-dev"];
const oaWorkflowTenants = (process.env.REACT_APP_INTERNAL_TENANTS || "trexo-ops")
    .split(",").map(t => t.trim().toLowerCase());
//TODO: check if localStorage.getItem("TENANT_NAME") is in array referenceDownloaderTenants
const showFiling371 = filing371Tenants.includes(getTenantName()?.toLowerCase());
const showReferenceDownloader = referenceDownloaderTenants.includes(getTenantName()?.toLowerCase());
const isOaWorkflowTenant = oaWorkflowTenants.includes(getTenantName()?.toLowerCase());

/**
 * Build collaboration space menu items.
 * @param {string|null} oaWorkflowRole - The user's OA workflow role (from /workflow/me), or null if not a workflow user.
 */
const getCollaborationMenus = (oaWorkflowRole = null) => {
    const baseChildren = [
        {
            uri: "/collaboration-space/my-files",
            label: "sidebar.menuItem.collaboration_my_files",
            type: "nav-item",
            icon: <FolderIcon sx={{ fontSize: 20 }} />
        },
        {
            uri: "/collaboration-space/workspace",
            label: "sidebar.menuItem.collaboration_workspace",
            type: "nav-item",
            icon: <WorkspacesIcon sx={{ fontSize: 20 }} />
        },
        {
            uri: "/collaboration-space/shared",
            label: "sidebar.menuItem.collaboration_shared",
            type: "nav-item",
            icon: <ShareIcon sx={{ fontSize: 20 }} />
        },
        ...(showReferenceDownloader ? [{
            uri: "/collaboration-space/reference-downloader",
            label: "sidebar.menuItem.collaboration_reference_downloader",
            type: "nav-item",
            icon: <PlagiarismOutlinedIcon sx={{ fontSize: 20 }} />
        }] : []),
        ...(showFiling371 ?
            [{
                uri: "/collaboration-space/371-filing-package",
                label: "sidebar.menuItem.collaboration_371_filing_package",
                type: "nav-item",
                icon: <PlagiarismOutlinedIcon sx={{ fontSize: 20 }} />
            }] : []
        )
    ];

    const rolesMap = typeof oaWorkflowRole === "string"
        ? { oaShell: oaWorkflowRole, postGrantSupport: oaWorkflowRole }
        : (oaWorkflowRole || {});

    const hasAnyWorkflowRole = Object.keys(rolesMap).length > 0;

    // Only show OA Shell or PGS if user has a workflow role AND tenant is an internal/operator tenant
    if (hasAnyWorkflowRole && isOaWorkflowTenant) {
        const oaRole = rolesMap.oaShell;
        if (oaRole) {
            const oaChildren = [
                {
                    uri: "/collaboration-space/oa-workflow/tasks",
                    label: "All OA Task",
                    type: "nav-item"
                }
            ];

            // Validation Result — Admin + Application Manager only
            if (oaRole === "Admin" || oaRole === "Application Manager") {
                oaChildren.push({
                    uri: "/collaboration-space/oa-workflow/batches",
                    label: "Validation Result",
                    type: "nav-item"
                });
            }

            baseChildren.push({
                uri: "/collaboration-space/oa-workflow",
                label: "OA Shell",
                type: "collapsible",
                icon: <AssignmentOutlinedIcon sx={{ fontSize: 20 }} />,
                children: oaChildren
            });
        }

        const pgsRole = rolesMap.postGrantSupport;
        if (pgsRole) {
            // Post Grant Support sub-menu
            const pgsChildren = [
                {
                    uri: "/collaboration-space/pgs-workflow/tasks",
                    label: "All PGS Tasks",
                    type: "nav-item"
                }
            ];

            if (pgsRole === "Admin" || pgsRole === "Application Manager") {
                pgsChildren.push({
                    uri: "/collaboration-space/pgs-workflow/validation-results",
                    label: "Validation Results",
                    type: "nav-item"
                });
            }

            baseChildren.push({
                uri: "/collaboration-space/pgs-workflow",
                label: "Post Grant Support",
                type: "collapsible",
                icon: <AssignmentOutlinedIcon sx={{ fontSize: 20 }} />,
                children: pgsChildren
            });
        }
    }

    return [{
        label: 'sidebar.menu.collaboration_space',
        type: "section",
        children: baseChildren
    }];
};

export default getCollaborationMenus;